<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/HERO Pages ALL 2.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        Our Services
      </h2>
    </div>

    <!-- SVG Curve (Aligned to Background) -->
    <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
      <path
        fill="#ffffff"
        d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
      ></path>
    </svg>
  </div>

  <!-- Our Services section -->
  <div class="py-10 bg-white">
    <div class="md:px-4 max-w-screen-xl mx-auto relative z-10">
      <div class="flex items-center strategic-card lg:-mt-24 -mt-8">
        <h2 class="text-yellow text-xl py-2 font-semibold px-4 lg:px-0">What We Offer</h2>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mt-10 px-4 lg:px-2">
        <!-- Left Side: Services List -->
        <div>
          <p class="text-base text-gray-700">
            Step into a world where your needs shape our services. Offering
            bespoke consultations, innovative design & automation, meticulous
            construction, and strategic project management, we make your journey
            seamless. Plus, unlock smart investment avenues for unparalleled
            ROI. With Mshel Homes, it's more than a home it's a lifetime
            investment.
          </p>
          <div class="mt-6 space-y-4">
            <!-- Card Component -->
            <div class="relative group cursor-pointer">
              <div
                class="flex items-center p-4 bg-gray-100 rounded-lg shadow-sm transition-all duration-300 ease-in-out group-hover:bg-yellow group-hover:min-h-[140px]"
              >
                <img
                  src="../assets/images/location (1).png"
                  alt="Real Estate"
                  class="w-8 h-8 transition-transform duration-300 ease-in-out group-hover:scale-110"
                />
                <div class="ml-4">
                  <h3
                    class="text-lg font-semibold transition-colors duration-300 ease-in-out group-hover:text-black"
                  >
                    Real Estate
                  </h3>
                  <p
                    class="text-sm opacity-0 max-h-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:max-h-[100px]"
                  >
                    In keeping to our commitment to excellence, we bring your
                    visions to reality, offering a complete turnkey design and
                    construction service.
                  </p>
                </div>
              </div>
            </div>

            <!-- Investment -->
            <div class="relative group cursor-pointer">
              <div
                class="flex items-center p-4 bg-gray-100 rounded-lg shadow-sm transition-all duration-300 ease-in-out group-hover:bg-yellow group-hover:min-h-[140px]"
              >
                <img
                  src="../assets/images/location (1).png"
                  alt="Investment"
                  class="w-8 h-8 transition-transform duration-300 ease-in-out group-hover:scale-110"
                />
                <div class="ml-4">
                  <h3
                    class="text-lg font-semibold transition-colors duration-300 ease-in-out group-hover:text-black"
                  >
                    Investment
                  </h3>
                  <p
                    class="text-sm opacity-0 max-h-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:max-h-[100px]"
                  >
                    Create the future you desire today. Mshel Homes provides a
                    platform to invest with an expectation of generating profit.
                  </p>
                </div>
              </div>
            </div>

            <!-- Real Estate Consultancy -->
            <div class="relative group cursor-pointer">
              <div
                class="flex items-center p-4 bg-gray-100 rounded-lg shadow-sm transition-all duration-300 ease-in-out group-hover:bg-yellow group-hover:min-h-[140px]"
              >
                <img
                  src="../assets/images/location (1).png"
                  alt="Real Estate Consultancy"
                  class="w-8 h-8 transition-transform duration-300 ease-in-out group-hover:scale-110"
                />
                <div class="ml-4">
                  <h3
                    class="text-lg font-semibold transition-colors duration-300 ease-in-out group-hover:text-black"
                  >
                    Real Estate Consultancy
                  </h3>
                  <p
                    class="text-sm opacity-0 max-h-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:max-h-[100px]"
                  >
                    Mshel Homes offers expert advice on commercial and real
                    estate development projects from start to finish.
                  </p>
                </div>
              </div>
            </div>

            <!-- Property Development -->
            <div class="relative group cursor-pointer">
              <div
                class="flex items-center p-4 bg-gray-100 rounded-lg shadow-sm transition-all duration-300 ease-in-out group-hover:bg-yellow group-hover:min-h-[140px]"
              >
                <img
                  src="../assets/images/location (1).png"
                  alt="Property Development"
                  class="w-8 h-8 transition-transform duration-300 ease-in-out group-hover:scale-110"
                />
                <div class="ml-4">
                  <h3
                    class="text-lg font-semibold transition-colors duration-300 ease-in-out group-hover:text-black"
                  >
                    Property Development
                  </h3>
                  <p
                    class="text-sm opacity-0 max-h-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:max-h-[100px]"
                  >
                    At Mshel Homes, we develop high-quality projects that meet
                    the needs of end users with a focus on luxury and
                    sustainability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Side: Image -->
        <div class="w-full">
          <img
            src="../assets/images/complex-aerial-view-city.jpg"
            alt="Construction"
            class="w-full h-full rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}
</style>
